<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="worktime"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1">
            Evidencija radnog vremena
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items v-if="item.id > 0">
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="copy_time_sheet()" v-bind="attrs" v-on="on">
                  <sabira_icon icon="copy" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Kopiraj u novi dan</span>
            </v-tooltip>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_delete_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="trash" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Obriši evidenciju</span>
            </v-tooltip>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Evidencija 1 dan</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-dialog
          width="30rem"
          persistent
          scrollable
          v-model="show_delete_options"
        >
          <v-card>
            <v-toolbar color="primary white--text" flat>
              <v-toolbar-title class="ml-1">
                Brisanje pojedinačne evidencije
              </v-toolbar-title></v-toolbar
            >
            <v-card-text class="pt-0 mt-0">
              <v-list color="transparent">
                <v-list-item>
                  <v-list-item-content>
                    {{ "Želite obrisati evidenciju?" }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions class="background">
              <v-btn text @click="show_delete_options = false">Odustani</v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="delete_time_sheet()">Obriši</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-tabs-items v-model="active_tab">
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-3">
                        <webpage_lookup_employees_time_sheet
                          update="wp_employee_changed_time_sheet"
                          :selected_id="item.employee_id"
                        ></webpage_lookup_employees_time_sheet>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-dialog
                          ref="valid_from"
                          v-model="show_work_date"
                          :return-value.sync="item.work_date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="work_date_formatted"
                              label="Datum na koji se odnosi evidencija"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              :width="80"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.work_date"
                            @change="save_work_date"
                            locale="bs-bs"
                            :first-day-of-week="1"
                            :show-week="true"
                          >
                          </v-date-picker>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-3 mt-0 pt-1">
                        <v-select
                          v-model="item.work_type"
                          mandatory
                          :items="work_types"
                          outlined
                          hide-details
                          label="Radna obaveza"
                        >
                        </v-select>
                      </v-list-item-content>
                    </v-list-item>
                    <div
                      style="display:grid; grid-template-columns: 1fr 1fr;grid-row-gap: 1rem;margin-bottom: 0.5rem;"
                    >
                      <v-list-item class="pl-4 pr-2">
                        <v-list-item-content>
                          <v-dialog
                            ref="hours_start"
                            v-model="show_hours_start"
                            :return-value.sync="item.hours_start"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="hours_start_formatted"
                                label="Početak radnog vremena"
                                prepend-inner-icon="mdi-clock-outline"
                                readonly
                                outlined
                                hide-details
                                v-bind="attrs"
                                v-on="on"
                              >
                              </v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="item.hours_start"
                              @change="save_hours_start"
                              locale="bs-bs"
                              @click:minutes="save_hours_start"
                            ></v-time-picker>
                          </v-dialog>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="pr-4 pl-2">
                        <v-list-item-content>
                          <v-dialog
                            ref="hours_end"
                            v-model="show_hours_end"
                            :return-value.sync="item.hours_end"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="hours_end_formatted"
                                label="Kraj radnog vremena"
                                prepend-inner-icon="mdi-clock-outline"
                                readonly
                                outlined
                                hide-details
                                v-bind="attrs"
                                v-on="on"
                                :width="80"
                              >
                              </v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="item.hours_end"
                              @change="save_hours_end"
                              locale="bs-bs"
                              @click:minutes="save_hours_end"
                            ></v-time-picker>
                          </v-dialog>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div
                      style="display:grid; grid-template-columns: 1fr 1fr;margin-bottom: 0.5rem;"
                    >
                      <v-list-item class="pl-4 pr-2">
                        <v-list-item-content>
                          <v-dialog
                            ref="break_start"
                            v-model="show_break_start"
                            :return-value.sync="item.break_start"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="break_start_formatted"
                                label="Početak pauze"
                                prepend-inner-icon="mdi-timer-outline"
                                readonly
                                outlined
                                hide-details
                                v-bind="attrs"
                                v-on="on"
                                :width="80"
                              >
                              </v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="item.break_start"
                              @change="save_break_start"
                              locale="bs-bs"
                              @click:minutes="save_break_start"
                            ></v-time-picker>
                          </v-dialog>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="pr-4 pl-2">
                        <v-list-item-content>
                          <v-dialog
                            ref="break_end"
                            v-model="show_break_end"
                            :return-value.sync="item.break_end"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="break_end_formatted"
                                label="Kraj pauze"
                                prepend-inner-icon="mdi-timer-outline"
                                readonly
                                outlined
                                hide-details
                                v-bind="attrs"
                                v-on="on"
                                :width="80"
                              >
                              </v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="item.break_end"
                              @change="save_break_end"
                              locale="bs-bs"
                              @click:minutes="save_break_end"
                            ></v-time-picker>
                          </v-dialog>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div
                      style="display:grid; grid-template-columns: 1fr 1fr;margin-bottom: 0.5rem;"
                    >
                      <v-list-item class="pl-4 pr-2">
                        <v-list-item-content>
                          <v-text-field
                            outlined
                            label="Prekovremeni sati"
                            hide-details
                            v-model="item.overtime"
                            type="number"
                          >
                          </v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="pr-4 pl-2">
                        <v-list-item-content>
                          <v-text-field
                            outlined
                            label="Obračunati sati"
                            hide-details
                            v-model="item.accounted_time"
                            type="number"
                          >
                          </v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          outlined
                          label="Napomena"
                          v-model="item.work_time_note"
                          maxlength="255"
                          counter
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content> </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content> </v-list-item-content>
                    </v-list-item>
                    <v-list-item> </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="is_btn_loading"
            text
            depressed
            @click="save_time_sheet()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_employees_time_sheet: () =>
      import("@/components/lookups/employees_time_sheet"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    show_delete_options: false,
    is_loading: true,
    is_btn_loading: false,
    time: null,
    menu2: false,
    active_tab: 0,
    show_work_date: null,
    title: "Kreiranje nove evidencije rada",
    selected_item: {
      id: null,
    },
    selected_work_type: "Izaberite vrstu radne obaveze",
    work_types: [
      { text: "Izaberite vrstu radne obaveze", value: null },
      { text: "Redovan rad", value: "Redovan rad" },
      { text: "Godišnji odmor", value: "Godišnji odmor" },
      { text: "Bolovanje", value: "Bolovanje" },
      { text: "Odsustvo", value: "Odsustvo" },
      { text: "Slobodan dan", value: "Slobodan dan" },
      { text: "Vjerski praznik", value: "Vjerski praznik" },
      { text: "Državni praznik", value: "Državni praznik" },
      { text: "Rad na vjerski praznik", value: "Rad na vjerski praznik" },
      { text: "Rad na državni praznik", value: "Rad na državni praznik" },
    ],
    show_hours_start: null,
    show_hours_end: null,
    show_break_start: null,
    show_break_end: null,
    selected_year: new Date().getFullYear(),
    years: [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4,
      new Date().getFullYear() - 5,
    ],
    item: {
      id: 0,
      employee_id: null,
      work_date: null,
      work_type: null,
      hours_start: null,
      break_start: null,
      break_end: null,
      hours_end: null,
      work_time_note: null,
      account_id: null,
      year: null,
      overtime: null,
      accounted_time: null,
    },
    visible: false,
  }),
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },

  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_time_sheet();
        } else {
          this.item = {
            employee_id: null,
            work_date: null,
            work_type: null,
            hours_start: null,
            break_start: null,
            break_end: null,
            hours_end: null,
            work_time_note: null,
            year: null,
            overtime: null,
            accounted_time: null,
            id: 0,
          };
          this.is_loading = false;
        }
      },
      immediate: false,
    },
  },
  methods: {
    delete_time_sheet() {
      this.$http({
        method: "POST",
        url: "/time_sheet/delete",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("show_status", {
            type: "success",
            message: "Evidencija je obrisana",
            timeout: 2000,
          });
          this.close_dialog();
          this.$webpageEventBus.$emit("reload_data");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: resp.data.message,
            timeout: 4000,
          });
        }
      });
    },
    copy_time_sheet() {
      this.item.id = 0;
      this.item.work_date = null;
      this.$webpageEventBus.$emit("show_status", {
        type: "primary",
        message: "Unesite novi datum",
        timeout: 2000,
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.item.employee_id == null || this.item.employee_id == 0) {
          has_errors = true;
          reject("Odabir uposlenika polje je obavezno");
        }
        if (this.item.work_date == null || this.item.work_date.length == 0) {
          has_errors = true;
          reject("Datum polje je obavezno");
        }
        if (this.item.work_type == null || this.item.work_type.length == 0) {
          has_errors = true;
          reject("Radna obaveza polje je obavezno");
        }
        if (
          this.item.accounted_time == null ||
          this.item.accounted_time.length == 0
        ) {
          has_errors = true;
          reject("Obračunati sati polje je obavezno");
        }
        if (this.item.accounted_time < 0 || this.item.accounted_time > 24) {
          has_errors = true;
          reject("Obračunati sati moraju biti između 0 i 24");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on(
        "wp_employee_changed_time_sheet",
        (selected_item) => {
          this.item.employee_id = selected_item.id;
        }
      );
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_employee_changed_time_sheet");
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_employee_time_sheet"
      );
    },
    save_work_date() {
      this.$refs.valid_from.save(this.item.work_date);
    },
    save_hours_start() {
      this.$refs.hours_start.save(this.item.hours_start);
    },
    save_hours_end() {
      this.$refs.hours_end.save(this.item.hours_end);
    },
    save_break_start() {
      this.$refs.break_start.save(this.item.break_start);
    },
    save_break_end() {
      this.$refs.break_end.save(this.item.break_end);
    },
    get_time_sheet() {
      this.$http({
        method: "POST",
        url: "/time_sheets/get_time_sheet",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        let r_item = resp.data.result[0];
        this.is_loading = false;
        this.item.id = r_item.id;
        this.item.employee_id = r_item.employee_id;
        this.item.work_date = this.$moment(new Date(r_item.work_date))
          .local()
          .format("YYYY-MM-DD HH:SS");
        this.item.work_type = r_item.work_type;
        this.item.hours_start = r_item.hours_start;
        this.item.break_start = r_item.break_start;
        this.item.break_end = r_item.break_end;
        this.item.hours_end = r_item.hours_end;
        this.item.work_time_note = r_item.work_time_note;
        this.item.year = r_item.year;
        this.item.overtime = r_item.overtime;
        this.item.accounted_time = r_item.accounted_time;
      });
    },
    save_time_sheet() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.item.work_date = this.$moment(new Date(this.item.work_date))
            .local()
            .format("YYYY-MM-DD HH:SS");
          this.item.account_id = this.$store.getters.user.account_id;
          this.item.year = this.item.work_date.substring(0, 4);
          this.$http({
            method: "POST",
            url: "/time_sheet/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Evidencija rada je ažurirana",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_employee_time_sheet");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
  computed: {
    work_date_formatted() {
      return this.item.work_date
        ? this.$moment(new Date(this.item.work_date)).format("DD MMMM YYYY")
        : null;
    },
    hours_start_formatted() {
      return this.item.hours_start
        ? this.$moment(this.item.hours_start, "HH:mm").format("HH:mm")
        : null;
    },
    hours_end_formatted() {
      return this.item.hours_end
        ? this.$moment(this.item.hours_end, "HH:mm").format("HH:mm")
        : null;
    },
    break_start_formatted() {
      return this.item.break_start
        ? this.$moment(this.item.break_start, "HH:mm").format("HH:mm")
        : null;
    },
    break_end_formatted() {
      return this.item.break_end
        ? this.$moment(this.item.break_end, "HH:mm").format("HH:mm")
        : null;
    },
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}

.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
